import { useEffect, useSyncExternalStore } from "react";
import i18n from "../config/i18n";
import { displayToast } from "../components/app/AppToast";

function subscribe(onChange: () => void): () => void {
  globalThis.addEventListener("online", onChange);
  globalThis.addEventListener("offline", onChange);
  return () => {
    globalThis.removeEventListener("online", onChange);
    globalThis.removeEventListener("offline", onChange);
  };
}

const useIsOffline = () => {
  const isOffline = useSyncExternalStore(subscribe, () => !navigator.onLine);

  useEffect(() => {
    if (!isOffline) return;
    displayToast(i18n.t("You are offline."), "warning");
  }, [isOffline]);

  return isOffline;
};

export default useIsOffline;
